import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MdDialog } from '@angular/material';
import { JobOffersService } from '../../services/job-offers.service';
import { JobsOffer } from '../../models/jobs-offer';
import { NgbTabChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder } from "@angular/forms";
import { ApplicantFilter } from '../../interfaces/filters';
import { ListCandidatesComponent } from '../list-candidates/list-candidates.component';
import { ListCandidatesService } from '../../services/list-candidates.service';
import { ApplyStatusService } from '../../services/apply-status.service';
import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'angular-2-dropdown-multiselect';
import { Subscription } from "rxjs/Subscription";
import {Observable} from "rxjs";
import { Constants } from '../constants';
import { MessageBoxDialog } from '../message-box/message-box.component';

@Component({
  selector: 'app-search-candidates',
  templateUrl: './search-candidates.component.html',
  styleUrls: ['./search-candidates.component.css']
})


export class SearchCandidatesComponent implements OnInit, OnDestroy {
  jobId: string;
  jobName: string;
  job: JobsOffer;
  loaded: boolean;

  optionsModel: number[];
  myOptions: IMultiSelectOption[];

  jobs:Observable<any>;
  candidates: any;
  errorMessage: string;

  form: FormGroup;
  hasReq: boolean = true;
  countReq: number;
  countNonReq: number;
  subscription: Subscription;

  offer_id:string;

  inviteView: boolean;
  searchView: boolean;

  mySettings: IMultiSelectSettings = {
    enableSearch: false,
    checkedStyle: 'glyphicon',
    buttonClasses: 'btn btn-default btn-block',
    dynamicTitleMaxItems: 10,
    displayAllSelectedText: true
};

  myTexts: IMultiSelectTexts = {
      checkAll: 'Seleccionar Todos',
      uncheckAll: 'Remover Todos',
      checked: 'Estado Seleccionado',
      checkedPlural: 'Estados Seleccionados',
      searchPlaceholder: 'Buscar',
      defaultTitle: 'Seleccionar Estado',
      allSelected: 'Seleccionar Todos',
  };

  advancedSearch:boolean;

  @ViewChild(ListCandidatesComponent) listCandidatesComponent: ListCandidatesComponent;

  public STATUS = Constants;

  constructor(private route: ActivatedRoute,
              private _router: Router,
              private fb: FormBuilder,
              private jobService: JobOffersService,
              private listCandidatesService: ListCandidatesService,
              private applyStatusService: ApplyStatusService,
              public dialog: MdDialog) {
    this.subscription = listCandidatesService.candidatesCountChanged$.subscribe(event => {
      //TODO: re-enable this
      // if(event.req) {
      //   this.countReq = event.count;
      // } else {
      //   this.countNonReq = event.count;
      // }
    });
  }

  ngOnInit() {

    this.advancedSearch = false;
    this.form = this.fb.group({
      query: [''],
      query_skill: [''],
      query_edu: [''],
      query_exp: [''],
      jobId: [''],
      jobName: [''],
      filters: this.fb.group({
        favorite: [''],
        read: [''],
        unread: [''],
        rejected: [''],
        screening: [''],
        interview: [''],
        test: [''],
        selected: [''],
        hired: [''],
        custom: ['']
      })
    });


    this.route.params.subscribe(params => {
      this.jobId = params['jobId'];

      if (typeof this.jobId != 'undefined') {
        if (this.route.snapshot.url[0].path == 'invite')  {
          this.inviteView = true;
        } else {
          this.searchView = true;
        }

        if (!this.inviteView) {
          this.form.controls['jobId'].setValue(this.jobId);
          this.form.value.jobId = this.jobId;
        }

        this.jobService.getOffersById(this.jobId).subscribe(
          data => {
            this.job = data;
            this.loaded = true;
          },
          error => this.errorMessage = <any>error
        );
      } else {
        this.form.controls['jobId'].setValue('');
      }
      let status = [];
      status.push('1');
      status.push('-1');
      status.push('-2');
      status.push('-6');
      this.jobs = this.jobService.getOffers(undefined, undefined, status, 1, 1000000).map(res => res.jobs);
    });
    this.applyStatusService.getApplyStatusList().subscribe(
      data => {
        let dat= [];
        data.applystatus.forEach(element => {
          dat.push({ id: element.id, name: element.name });
        });
        this.myOptions = dat;
      }
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getOfferInput($event){
    this.offer_id = $event.id;
  }

  onChange($event) {
  }

  updateFilters(filters: ApplicantFilter, valid: boolean) {
    if (valid) {
      this.listCandidatesComponent.refreshListing(1);
    }
  }

  beforeTabChange($event: NgbTabChangeEvent) {
    this.hasReq = $event.nextId === 'reqyes';
  }

  onAdvanceSearch() {
    if (this.advancedSearch) {
      this.advancedSearch = false;
    } else {
      this.advancedSearch = true;
    }
  }

  putOffersStatus(job, status) {
    this.jobService.putOffersStatus(job.id, status)
      .subscribe(
        data => { 
        },
        error => this.errorMessage = <any>error
      );
  }

  viewJob(jobId) {
    this._router.navigate(['/viewoffer', jobId]);
  }

  viewJobKanban(jobId) {
    this._router.navigate(['/viewjob', jobId]);
  }

  viewIvite(id) {
    this._router.navigate(['/viewinvite/'+id]);
  }

  showInformation() {
    this.dialog.open(MessageBoxDialog, {data: {message: 'Invita a los candidatos postulados Filtra tus ofertas según el esta de la misma Activas, inactivas, Premium señalando en los cuadros de los estados uno o más niveles de filtros.', information: true, showIcon: true}});
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/search-candidates/search-candidates.component.ts